export const reSpecificWeightConstants = {
	GetKinds: {
		FAILURE : 'GET_HOUSING_CONSTRUCTION_KINDS_FAILURE',
		REQUEST : 'GET_HOUSING_CONSTRUCTION_KINDS_REQUEST',
		SUCCESS : 'GET_HOUSING_CONSTRUCTION_KINDS_SUCCESS'
	},
	GetList: {
		FAILURE : 'GET_SPECIFIC_WEIGHTS_LIST_FAILURE',
		REQUEST : 'GET_SPECIFIC_WEIGHTS_LIST_REQUEST',
		SUCCESS : 'GET_SPECIFIC_WEIGHTS_LIST_SUCCESS'
	},
	GetPaged: {
		FAILURE : 'GET_SPECIFIC_WEIGHTS_PAGED_FAILURE',
		REQUEST : 'GET_SPECIFIC_WEIGHTS_PAGED_REQUEST',
		SUCCESS : 'GET_SPECIFIC_WEIGHTS_PAGED_SUCCESS'
	},
	Upload: {
		FAILURE : 'UPLOAD_SPECIFIC_WEIGHTS_FAILURE',
		REQUEST : 'UPLOAD_SPECIFIC_WEIGHTS_REQUEST',
		SUCCESS : 'UPLOAD_SPECIFIC_WEIGHTS_SUCCESS'
	},
	GetExampleFile: {
		FAILURE : 'DOWNLOAD_EXAMPLE_FILE_FAILURE',
		REQUEST : 'DOWNLOAD_EXAMPLE_FILE_REQUEST',
		SUCCESS : 'DOWNLOAD_EXAMPLE_FILE_SUCCESS'
	},
	CLEAR: 'CLEAR_SPECIFIC_WEIGHTS'

}